import api from '~/services/api';
import { IbsCbsPorCodigo, ResponseIbsCbsProps } from '../protocols';

const URL_ROOT = '/classificacao-ibs-cbs';

const retornaCodIbsCbsPadrao = async (): Promise<number | null> => {
  const { data } = await api.get<ResponseIbsCbsProps<number | null>>(
    `${URL_ROOT}/ibs-cbs-padrao`,
  );

  if (!data.success || !data.data) return null;
  return data.data;
};

const getIbsCbsPorCodigo = async (
  cod_ibs_cbs: number,
): Promise<IbsCbsPorCodigo | null> => {
  const { data } = await api.get<ResponseIbsCbsProps<IbsCbsPorCodigo>>(
    `${URL_ROOT}/ibs-cbs/${cod_ibs_cbs}`,
  );
  if (!data.success) return null;
  return data.data;
};

const retornaIBSEst = async (
  cod_ibs_cbs: number,
  des_sigla: string,
): Promise<{ per_aliq_ibs_est: number }> => {
  const { data } = await api.get<
    ResponseIbsCbsProps<{ per_aliq_ibs_est: number }>
  >(`${URL_ROOT}/ibs-est/${cod_ibs_cbs}/${des_sigla}`);
  if (!data.success) return { per_aliq_ibs_est: 0 };
  return data.data;
};

const retornaIBSMun = async (
  cod_ibs_cbs: number,
  cod_cidade: number,
  des_sigla: string,
): Promise<{ perAliqIbsMun: number }> => {
  const { data } = await api.get<
    ResponseIbsCbsProps<{ perAliqIbsMun: number }>
  >(`${URL_ROOT}/ibs-mun/${cod_ibs_cbs}/${cod_cidade}/${des_sigla}`);
  if (!data.success) return { perAliqIbsMun: 0 };
  return data.data;
};

const retornaRedIBS = async (
  cod_ibs_cbs: number,
  des_sigla: string,
): Promise<{ per_red_ibs: number }> => {
  const { data } = await api.get<ResponseIbsCbsProps<{ per_red_ibs: number }>>(
    `${URL_ROOT}/red-ibs/${cod_ibs_cbs}/${des_sigla}`,
  );
  if (!data.success) return { per_red_ibs: 0 };
  return data.data;
};

export const servicesIbsCbs = {
  retornaCodIbsCbsPadrao,
  getIbsCbsPorCodigo,
  retornaIBSEst,
  retornaIBSMun,
  retornaRedIBS,
};
